import React, { useContext } from 'react'
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import { diskSizeContext } from '../pages/Global/Elements/diskSizeContext';
import { organizationContext } from '../pages/Organization/organizationContext';

export function DiskSpaceLowMessage() {
    const [organization, setOrganization] = useContext(organizationContext);
    const [diskSize, setDiskSize] = useContext(diskSizeContext);
    return (
        <div class="well">
            <h1 class="grey lighter smaller">
                <span class="red bigger-125">
                    <i class="ace-icon fa fa-random"></i> Insufficient Disk Space
                </span>
            </h1>

            <hr />
            <h3 class="lighter smaller red">
                Your disk space is running <b>low</b>, you are using <b>{Number(diskSize.totalSize).toFixed(0)} MB</b>, Alloated size is <b>{Number(organization.allotedDiskSizeMB).toFixed(0)} MB</b>, please contact with baithka team or seller to increase alloted disk size.
            </h3>

            <div class="space"></div>

            <div>
                <h4 class="lighter smaller">Meanwhile, try one of the following for increasing disk space:</h4>

                <ul class="list-unstyled spaced inline bigger-110 margin-15">
                    <li>
                        <i class="ace-icon fa fa-hand-o-right blue"></i> Contact with Baithka team or seller.
                    </li>
                    <li>
                        <i class="ace-icon fa fa-hand-o-right blue"></i> Or click to visit recharge center <Link to="/rechargeplans">Recharge Now</Link>.
                    </li>
                    <li>
                        <i class="ace-icon fa fa-hand-o-right blue"></i> Visit to <a href="https://baithka.com" target="_blank">www.baithka.com</a> or <a href="https://cubicle8.com" target="_blank">www.cubicle8.com</a>.
                    </li>
                </ul>
            </div>
        </div>
    )
}
